<template>
  <div style="padding-top: 30px">
    <el-form :model="roleFrom" label-width="100px">
      <el-form-item label="物料受入" prop="type">
        <el-checkbox-group v-model="roleFrom.iconList">
          <el-checkbox label="玻璃检查" name="type"></el-checkbox>
          <el-checkbox label="部品检查" name="type"></el-checkbox>
          <el-checkbox label="型材检查" name="type"></el-checkbox>
          <el-checkbox label="部品同送检查" name="type"></el-checkbox>
          <el-checkbox label="玻璃不良处理" name="type"></el-checkbox>
          <el-checkbox label="部品不良处理" name="type"></el-checkbox>
          <el-checkbox label="型材不良处理" name="type"></el-checkbox>
          <el-checkbox label="部品同送不良处理" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="切断/加工" prop="type">
        <el-checkbox-group v-model="roleFrom.iconList">
          <el-checkbox label="切断检查" name="type"></el-checkbox>
          <el-checkbox label="CNC检查" name="type"></el-checkbox>
          <el-checkbox label="模具冲压检查" name="type"></el-checkbox>
          <el-checkbox label="铣床加工检查" name="type"></el-checkbox>
          <el-checkbox label="直交切断检查" name="type"></el-checkbox>
          <el-checkbox label="三次元检查" name="type"></el-checkbox>
          <el-checkbox label="外加工检查" name="type"></el-checkbox>
          <el-checkbox label="切断进度查看" name="type"></el-checkbox>
          <el-checkbox label="切断不良处理" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="涂装" prop="type">
        <el-checkbox-group v-model="roleFrom.iconList">
          <el-checkbox label="涂装接收" name="type"></el-checkbox>
          <el-checkbox label="前处理上料" name="type"></el-checkbox>
          <el-checkbox label="前处理" name="type"></el-checkbox>
          <el-checkbox label="试验片记录" name="type"></el-checkbox>
          <el-checkbox label="粉体检查" name="type"></el-checkbox>
          <el-checkbox label="氟素检查" name="type"></el-checkbox>
          <el-checkbox label="涂料入货检查" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="组立" prop="type">
        <el-checkbox-group v-model="roleFrom.iconList">
          <el-checkbox label="组立检查" name="type"></el-checkbox>
          <el-checkbox label="前部品" name="type"></el-checkbox>
          <el-checkbox label="组立玻璃检查" name="type"></el-checkbox>
          <el-checkbox label="后部品" name="type"></el-checkbox>
          <el-checkbox label="重点检查一" name="type"></el-checkbox>
          <el-checkbox label="重点检查二" name="type"></el-checkbox>
          <el-checkbox label="重点检查三" name="type"></el-checkbox>
          <el-checkbox label="完成品检查" name="type"></el-checkbox>
          <el-checkbox label="散料同送检查" name="type"></el-checkbox>
          <el-checkbox label="组立进度查看" name="type"></el-checkbox>
          <el-checkbox label="组立不良处理" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" @click="addRoleApp">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "AppPermission",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      roleFrom: {},
      loading: false
    }
  },
  methods:{
    async addRoleApp(){
      this.loading = true;
      let {data: res} = await this.$axios.post('/api/app/addAppPermission',this.roleFrom);
      this.loading = false;
      if (!res.success) {
        this.$message.error(res.message);
      } else {
        this.$message.success('App权限编辑成功');
      }
    },
    async getAppList(){
      let {data: res} = await this.$axios.get('/api/app/permission?id='+this.parentData.id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.roleFrom.id = this.parentData.id
        this.roleFrom.name = this.parentData.name
        this.roleFrom.iconList = res.data
      }
    }
  },
  created() {
    this.getAppList()
  }
}
</script>

<style scoped>

</style>
